import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemDoName, FormItemDoNo} from '../DO/FormChooseDo.jsx'

export default function FormChoose(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemDoNo />
            <FormItemDoName />
        </FormChooseExternal>
    )
}
